import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";
import Select from "../../../../../common/StyledSelect";

const styles = (theme) => ({
  outerMostWrapper: {
    zIndex: 2,
    position: "absolute",
    pointerEvents: "auto",
    top: "3%",
    left: "2%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.ModalBGColor,
    width: "40%",
  },
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
      marginTop: "0px",
      marginBottom: "0px",
    },
  },
});

class SelectRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRoute: null,
      routeComplianceList: [],
    };
  }

  componentDidMount = () => {
    const routeComplianceList = this.props.routeComplianceList.map((route) => {
      return {
        label: `${route.driverName}${
          route.routeName ? ` - ${route.routeName}` : ""
        }`,
        value: route.routeId,
      };
    });
    this.setState({
      routeComplianceList: routeComplianceList,
    });
    const selectedRoute = {
      label: `${this.props.selectedRoute.driverName}${
        this.props.selectedRoute.routeName
          ? ` - ${this.props.selectedRoute.routeName}`
          : ""
      }`,
      value: this.props.selectedRoute.routeId,
    };
    this.handleChange(selectedRoute);
  };

  handleChange = (value) => {
    if (value) {
      this.props.updateNextStopComplianceSelectedRoute(
        this.props.routeComplianceList.find(
          (route) => route.routeId === value.value
        )
      );
      this.setState({ selectedRoute: value.value });
    }
  };

  render() {
    const { classes } = this.props;
    const { routeComplianceList } = this.state;

    return (
      <Paper className={classes.outerMostWrapper}>
        <div className={classes.flexRow}>
          <Select
            textFieldProps={{
              id: "Routes",
              label: "",
              variant: "outlined",
            }}
            value={this.state.selectedRoute}
            isMulti={false}
            onChange={this.handleChange}
            data={routeComplianceList}
            isClearable={false}
          />
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(SelectRoute);
